class BackInStock extends HTMLElement {
  constructor() {
    super();

    this.$trigger = this.querySelector('.js-open-bis-button');
    this.$variantsSelector = this.querySelector('#bis-selector');
    this.$emailField = this.querySelector('#bis-email');
    this.$productTitle = this.querySelector('#bis-title');

    document.addEventListener('variant:changed', (event) => {
      const variant = event.detail.variant;
      const {available} = variant;

      if (available) {
        this.$trigger.classList.remove('show');
        return;
      }
      
      this.$trigger.classList.add('show');
    });

    this.initBackInStock();
  }

  initBackInStock() {
    this.initOpenBackInStockButton();
    this.setBackInStockData();
    this.initSubmitBackInStockDataButton();
    this.initPopup();

    window.backInStockButtonVisibility = this.backInStockButtonVisibility;
  }
  initOpenBackInStockButton() {
    this.$trigger.addEventListener('click', () => {
      const productHasOnlyDefaultVariant = (document.querySelectorAll("product-variants input").length === 0);
      const $variantSelector = document.querySelector('product-variants');
      const variantId = productHasOnlyDefaultVariant ? document.querySelector('input[name="id"]').value : $variantSelector.selectedVariant.id;

      this.resetBackInStockPopup();

      this.querySelector("#bis-selector").value = variantId;

      productHasOnlyDefaultVariant
      ? this.classList.add("hidden")
      : this.classList.remove("hidden");

      window.openPopup('back-in-stock');
    });

    /* Código original */
      // this.$trigger.on('click', () => {
      //   const productHasOnlyDefaultVariant = ($('.swatch-element input').length === 0);
      //   const $variantSelector = this.container.querySelector('variant-radios');
      //   const variantId = productHasOnlyDefaultVariant ? $('input[name="id"]').val() : $variantSelector.currentVariant.id;

      //   this.resetBackInStockPopup();

      //   $('#bis-selector').val(variantId);

      //   productHasOnlyDefaultVariant
      //   ? $('.bis-selector-wrapper').addClass('hidden')
      //   : $('.bis-selector-wrapper').removeClass('hidden');

      //   window.openPopup('back-in-stock');
      // });
    /* Código original */
  }
  backInStockButtonVisibility(visibility) {
    visibility === 'hidden'
    ? this.$trigger.classList.remove('show')
    : this.$trigger.classList.add('show');
  }
  resetBackInStockPopup() {
    const $advices = this.querySelectorAll('.bis-form-error, .bis-success');

    $advices.forEach(function(element) {
      element.classList.remove('show');
    });

    /* Código original */
      // $('.bis-form-error')
      //   .add('.bis-success')
      //   .removeClass('show');
    /* Código original */
  }
  setBackInStockData() {
    const productTitle = document.querySelector('product-meta .product-meta__title').textContent;
    this.$productTitle.textContent = productTitle;
  }
  initSubmitBackInStockDataButton() {

    const $submitButton = this.querySelector('.js-send-bis-form');

    const validateEmail = () => {
      const email = this.querySelector('#bis-email').value;
      return email.match(
        // eslint-disable-next-line no-useless-escape, comma-dangle
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
    };

    const onError = () => {
      this.querySelector('.bis-form-error').classList.add('show');
    };

    const onSuccess = () => {
      this.querySelector('.bis-success').classList.add('show');
      document.body.classList.remove('no-touch');
    };

    const getFormData = () => {
      return {
        "data": {
          "type": "back-in-stock-subscription",
          "attributes": {
            "profile": {
              "data": {
                  "type": "profile",
                  "attributes": {
                      "email": `${this.querySelector('#bis-email').value}`,
                  }
              }
            },
            "channels": ["EMAIL"],
          },
          "relationships": {
            "variant": {
              "data": {
                "type": "catalog-variant",
                "id": `$shopify:::$default:::${Number(this.$variantsSelector.value)}`
              }
            }
          }
        }
      };
    };

    /* Si hay error, desaparecer el mensaje de error en cuanto el Email sea correcto */
    this.$emailField.addEventListener('input', () => {
      const hasError = this.querySelector('.bis-form-error').classList.contains('show');

      if (!hasError) {
        return;
      }

      const emailIsValid = validateEmail();

      if (emailIsValid) {
        this.querySelector('.bis-form-error').classList.remove('show');
      }
    });

    $submitButton.addEventListener('click', () => {
      const emailIsValid = validateEmail();

      if (!emailIsValid) {
        onError();
        return;
      }

      document.body.classList.add('no-touch');
      this.querySelector('.bis-form-error').classList.remove('show');

      const formData = getFormData();

      var requestOptions = {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "revision":"2024-06-15"
        },
        body: JSON.stringify(formData),
    };
    
    fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=UWGcGD", requestOptions)
      .then(result => {
        onSuccess();
      })
      .catch(error => console.log('error', error));
    });
  }

  initPopup() {
    const $popup = this.querySelector('#popup');
    const $contentBoxes = document.querySelectorAll('.popup-content-box');

    function openPopup(action) {
      document.body.classList.add('disable-scroll');
      $contentBoxes.forEach(box => box.classList.remove('active'));
      $contentBoxes.forEach(box => {
        if (box.dataset.action === action) {
          box.classList.add('active');
        }
      });
      $popup.setAttribute('data-active-popup', action);
      $popup.classList.add('open');
      $('#bis-email').prop('required', true);
    }

    function closePopup() {
      document.body.classList.remove('disable-scroll');
      document.querySelectorAll('.popup-delete-product-button').forEach(button => {
        button.removeAttribute('href');
      });
      $popup.removeAttribute('data-active-popup');
      $popup.classList.remove('open');
      $('#bis-email').prop('required', false);
    }

    function initTriggers() {
      document.querySelectorAll('.js-open-popup').forEach(trigger => {
        trigger.removeEventListener('click', openPopup);
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          const { popupAction } = event.target.dataset;
          openPopup(popupAction);
        });
      });

      document.querySelectorAll('.js-close-popup').forEach(trigger => {
        trigger.addEventListener('click', closePopup);
      });
    }

    initTriggers();

    window.openPopup = openPopup;
    window.closePopup = closePopup;
  }
}
customElements.define('back-in-stock', BackInStock);